import { render } from "./editIcon.svg?vue&type=template&id=1b95d390"
const script = {}
script.render = render

export default script